export default __webpack_public_path__ + "static/media/delete-mini.852e1d67.svg";